import { useEffect, useState } from "react";
import { useLivekitContext } from "@/context/features/livekit/LivekitRoomContext";
import { Room, RoomEvent, Track } from "livekit-client";

export function useScreenShareActive(): boolean {
  const { livekitContext } = useLivekitContext();
  const room = livekitContext?.room as Room | undefined;
  const [active, setActive] = useState(false);

  const computeActive = (r: Room | undefined): boolean => {
    if (!r) return false;

    // Local
    if (r.localParticipant.getTrackPublication(Track.Source.ScreenShare)?.track)
      return true;

    // Remote
    for (const p of r.remoteParticipants.values()) {
      const pub = p.getTrackPublication(Track.Source.ScreenShare);
      if (pub?.isSubscribed && pub.track) return true;
    }
    return false;
  };

  useEffect(() => {
    if (!room) {
      setActive(false);
      return;
    }

    const update = () => setActive(computeActive(room));

    // Listen for all relevant events
    const evts: RoomEvent[] = [
      RoomEvent.TrackSubscribed,
      RoomEvent.TrackUnsubscribed,
      RoomEvent.LocalTrackPublished,
      RoomEvent.LocalTrackUnpublished,
      RoomEvent.ParticipantConnected,
      RoomEvent.ParticipantDisconnected,
      RoomEvent.TrackPublished,
      RoomEvent.TrackUnpublished,
    ];

    evts.forEach((e) => room.on(e, update));
    return () => evts.forEach((e) => room.off(e, update));
  }, [room]);

  return active;
}
